<style scoped lang="scss">
@import '@/assets/scss/_inputs-shared.scss';
</style>
<template>
  <div class="step1-container">
      <!-- Título y selector de curso -->
      <div class="section-title">Curso</div>
      <div class="section-subtitle">El 2027 seré estudiante de:</div>
      <div class="year-selector">
        <button
          v-for="option in yearOptions"
          :key="option.value"
          :class="['year-btn', { active: String(localState.year) === String(option.value) }]"
          @click="selectYear(option.value)"
        >
          {{ option.label }}
        </button>
      </div>

      <!-- Indicador de carga -->
      <div v-if="loading" class="loading-indicator">
        <div class="spinner"></div>
        <p>Cargando programas...</p>
      </div>

      <!-- Sección Modalidad (agrupada por Metas.name) -->
      <div class="card-section" v-if="!loading && modalidades.length && localState.year">
        <div class="section-title">Modalidad</div>
        <div class="section-subtitle">Selecciona bajo qué modalidad quieres estudiar:</div>
        <div class="toggle-btns">
          <button
            v-for="mod in modalidades"
            :key="mod.name"
            :class="['toggle-btn', { active: localState.modalidad === mod.name }]"
            @click="selectModalidad(mod.name)"
          >
            {{ getModalidadDisplayName(mod.name) }}
          </button>
        </div>
        <div v-if="showModalidadDetails && localState.modalidad" class="details-cards">
          <div class="details-card organized-details">
            <div class="details-title">{{ getModalidadDisplayName(localState.modalidad) }}</div>
            <ul class="main-details-list">
              <li v-for="(detail, idx) in modalidadMainDetails" :key="idx">
                <span class="icon-detail green">✔</span>
                <span class="main-detail-label">{{ detail.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="details-toggle" v-if="localState.modalidad" @click="showModalidadDetails = !showModalidadDetails">
          <span>{{ showModalidadDetails ? 'Ocultar detalles' : 'Ver detalles' }}</span>
          <svg
            :class="['arrow-icon', { rotated: showModalidadDetails }]"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Sección Programa (filtrada por modalidad seleccionada) -->
      <div class="card-section" v-if="!loading && filteredPrograms.length && localState.modalidad">
        <div class="section-title">Programa</div>
        <div class="section-subtitle">Selecciona el programa que quieres estudiar:</div>
        <div class="toggle-btns">
          <button
            v-for="prog in filteredPrograms"
            :key="prog.id"
            :class="['toggle-btn', { active: localState.program && localState.program.id === prog.id }]"
            @click="selectProgram(prog)"
          >
            {{ getShortProgramName(prog.name) }}
          </button>
        </div>
        <div v-if="showProgramDetails && localState.program" class="details-cards">
          <div class="details-card organized-details">
            <div class="details-title">{{ getShortProgramName(localState.program.name) }}</div>
            <ul class="main-details-list">
              <li v-for="(detail, idx) in programMainFalseDetails" :key="idx">
                <span class="icon-detail green">✔</span>
                <span class="main-detail-label">{{ detail.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="details-toggle" v-if="localState.program" @click="showProgramDetails = !showProgramDetails">
          <span>{{ showProgramDetails ? 'Ocultar detalles' : 'Ver detalles' }}</span>
          <svg
            :class="['arrow-icon', { rotated: showProgramDetails }]"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Botones de navegación -->
      <div class="nav-btns">
        <button class="back-btn" @click="goToHome">&larr; Volver</button>
        <button class="continue-btn" :disabled="!canContinue" @click="goToNextStep">Continuar &rarr;</button>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 140px;">
        <FeatureCards />
      </div>
      <InfoHelpGrid />
    </div>
</template>

<script>

import InfoHelpGrid from '@/components/featured/InfoHelpGrid.vue'
import FeatureCards from '@/components/featured/featuredCards.vue'
import { programsService } from '@/services'

export default {
  name: 'NewVersionStep1',

 
  components: {
    InfoHelpGrid,
    FeatureCards,
  },


  props: {
    stepperData: {
      type: Object,
      default: () => ({
        year: null,
        modalidad: null,
        program: null,
        completed: false
      })
    }
  },

  // Estado reactivo local del componente
  data() {
    return {
      // Opciones de años escolares (Disabled 1 and 2 due client requirement)
      yearOptions: [
        // { label: '1° Medio', value: 1 },
        // { label: '2° Medio', value: 2 },
        { label: '3° Medio', value: 3 },
        { label: '4° Medio', value: 4 },
        { label: 'Egresado', value: 'e' }
      ],
      // Lista de programas básicos cargados desde API para modalidades
      basicPrograms: [],
      // Lista de programas con ubicaciones cargados desde API específica
      programsWithLocations: [],
      // Indicador de carga
      loading: false,
      // Estado local para guardar selecciones del usuario
      localState: {
        year: null,
        modalidad: null,
        program: null
      },
      // Banderas para mostrar u ocultar detalles
      showProgramDetails: false,
      showModalidadDetails: false,
      
      // Detalles estáticos para modalidades por curso
      staticModalidadDetails: {
        // 1° y 2° Medio - Solo Presencial (Disabled due client requirement)
        // '1-presencial': [
        //   { name: '1 Clase Semanal', value: 'si' },
        //   { name: '25 Estudiantes promedio por Sala', value: 'si' },
        //   { name: '1.0 X Referencia de Precio', value: 'si' }
        // ],
        // '2-presencial': [
        //   { name: '1 Clase Semanal', value: 'si' },
        //   { name: '25 Estudiantes promedio por Sala', value: 'si' },
        //   { name: '1.0 X Referencia de Precio', value: 'si' }
        // ],
        // 3°, 4° Medio y Egresado - Presencial
        '3-presencial': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        '4-presencial': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        'e-presencial': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        // 3°, 4° Medio y Egresado - Online/Streaming
        '3-online': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '0.7 X Referencia de Precio', value: 'si' }
        ],
        '4-online': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '0.7 X Referencia de Precio', value: 'si' }
        ],
        'e-online': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '0.7 X Referencia de Precio', value: 'si' }
        ],
        '3-streaming': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '0.7 X Referencia de Precio', value: 'si' }
        ],
        '4-streaming': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '0.7 X Referencia de Precio', value: 'si' }
        ],
        'e-streaming': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: 'Opción Grupo de Estudio', value: 'si' },
          { name: '0.7 X Referencia de Precio', value: 'si' }
        ]
      },
      
      // Detalles estáticos para programas por curso
      staticProgramDetails: {
        // 1° y 2° Medio - Solo Sube Nota (Disabled due client requirement)
        // '1-sube nota': [
        //   { name: '1 Clase Semanal', value: 'si' },
        //   { name: '25 Estudiantes promedio por Sala', value: 'si' },
        //   { name: '1.0 X Referencia de Precio', value: 'si' }
        // ],
        // '2-sube nota': [
        //   { name: '1 Clase Semanal', value: 'si' },
        //   { name: '25 Estudiantes promedio por Sala', value: 'si' },
        //   { name: '1.0 X Referencia de Precio', value: 'si' }
        // ],
        // 3°, 4° Medio y Egresado - Tradicional
        '3-tradicional': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '35 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        '4-tradicional': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: '35 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        '4-tradicional pdvx':[
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: '50 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        // Invierno tiene clave propia: antes caía en el fallback 'e-tradicional'
        // y mostraba los detalles del programa Anual.
        'e-tradicional invierno': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '35 Estudiantes promedio por Sala', value: 'si' },
          { name: '0.8 X Referencia de Precio', value: 'si' }
        ],
        'e-tradicional invierno pdvx': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '35 Estudiantes promedio por Sala', value: 'si' },
          { name: '0.8 X Referencia de Precio', value: 'si' }
        ],
        'e-tradicional': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '35 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],   
        'e-tradicional pdvx': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '50 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        // 3°, 4° Medio y Egresado - Grupo de Estudio
        '3-grupo de estudio': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: '10 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.3 X Referencia de Precio', value: 'si' }
        ],
        // Hijos de Pre PAES 3° medio (programas 908 y 927 en producción).
        // Deben ir con clave exacta: el fallback por 'grupo de estudio' los
        // mandaría a '3-grupo de estudio', que corresponde a otro programa.
        '3-grupo de estudio 12 pre paes': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: '12 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.5 X Referencia de Precio', value: 'si' }
        ],
        '3-grupo de estudio 12 pre paes pdvx': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: '12 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.5 X Referencia de Precio', value: 'si' }
        ],
        '3-pre paes': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: '35 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        '3-pre paes pdvx': [
          { name: '1 Clase Semanal', value: 'si' },
          { name: '50 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.0 X Referencia de Precio', value: 'si' }
        ],
        // Claves específicas por tamaño de grupo. Van antes del fallback genérico
        // '4-grupo de estudio' porque programMainFalseDetails prueba primero la
        // coincidencia exacta '{curso}-{nombre corto en minúsculas}'.
        '4-grupo de estudio 6': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: '6 Estudiantes promedio por Sala', value: 'si' },
          { name: '2.0 X Referencia de Precio', value: 'si' }
        ],
        '4-grupo de estudio 12': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: '12 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.5 X Referencia de Precio', value: 'si' }
        ],
        '4-grupo de estudio 12 pdvx': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: '12 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.5 X Referencia de Precio', value: 'si' }
        ],
        '4-grupo de estudio': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: '10 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.3 X Referencia de Precio', value: 'si' }
        ],
        '4-grupo de estudio pdvx': [
          { name: '1-2 Clases Semanales', value: 'si' },
          { name: '10 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.3 X Referencia de Precio', value: 'si' }
        ],
        'e-grupo de estudio 6': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '6 Estudiantes promedio por Sala', value: 'si' },
          { name: '2.0 X Referencia de Precio', value: 'si' }
        ],
        'e-grupo de estudio 12': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '12 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.5 X Referencia de Precio', value: 'si' }
        ],
        'e-grupo de estudio 12 pdvx': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '12 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.5 X Referencia de Precio', value: 'si' }
        ],
        'e-grupo de estudio': [
          { name: '1-3 Clases Semanales', value: 'si' },
          { name: '10 Estudiantes promedio por Sala', value: 'si' },
          { name: '1.3 X Referencia de Precio', value: 'si' }
        ]
      }
    }
  },

  // Propiedades computadas (derivan valores del estado)
  computed: {
    // Lista de modalidades únicas extraídas de los programas básicos
    modalidades() {
      // Solo mostrar modalidades si hay un año seleccionado
      if (!this.localState.year) {
        return []
      }
      
      const map = {}
      this.basicPrograms.forEach(p => {
        if (p.Metas && p.Metas.name) {
          map[p.Metas.name] = {
            name: p.Metas.name,
            order: p.Metas.order || 999 // Si no hay order, poner al final
          }
        }
      })
      const modalidades = Object.values(map).sort((a, b) => a.order - b.order)
      return modalidades
    },

    // Muestra todos los programas con ubicaciones cargados (sin filtrar por modalidad)
    filteredPrograms() {
      if (!this.programsWithLocations.length) return []
      // Ordenar programas por campo order de menor a mayor
      return [...this.programsWithLocations].sort((a, b) => {
        const orderA = a.order || 999
        const orderB = b.order || 999
        return orderA - orderB
      })
    },

    // Detalles estáticos para modalidades
    modalidadMainDetails() {
      if (!this.localState.modalidad || !this.localState.year) return []
      
      const modalidadKey = this.getModalidadDisplayName(this.localState.modalidad).toLowerCase()
      const yearKey = this.localState.year === 'e' ? 'e' : String(this.localState.year)
      const combinedKey = `${yearKey}-${modalidadKey}`
      
      return this.staticModalidadDetails[combinedKey] || []
    },

    // Detalles estáticos para programas
    programMainFalseDetails() {
      if (!this.localState.program || !this.localState.year) return []
      
      const programName = this.getShortProgramName(this.localState.program.name).toLowerCase()
      const yearKey = this.localState.year === 'e' ? 'e' : String(this.localState.year)
      
      // Buscar coincidencia exacta primero (curso-programa)
      const exactKey = `${yearKey}-${programName}`
      if (this.staticProgramDetails[exactKey]) {
        return this.staticProgramDetails[exactKey]
      }
      
      // Si no encuentra coincidencia exacta, buscar por palabras clave
      if (programName.includes('grupo de estudio')) {
        const key = `${yearKey}-grupo de estudio`
        return this.staticProgramDetails[key] || []
      }
      
      if (programName.includes('tradicional')) {
        const key = `${yearKey}-tradicional`
        return this.staticProgramDetails[key] || []
      }
      
      if (programName.includes('sube nota')) {
        const key = `${yearKey}-sube nota`
        return this.staticProgramDetails[key] || []
      }
      
      return []
    },

    // Detalles sin categoría (para compatibilidad con template)
    programNoCategoryDetails() {
      return this.programMainFalseDetails
    },

    // Categorías vacías (para compatibilidad con template)
    programCategories() {
      return []
    },

    // Determina si se puede continuar al siguiente paso
    canContinue() {
      return !!(
        this.localState.year &&
        this.localState.modalidad &&
        this.localState.program
      )
    },

    // Obtiene el ID de la modalidad seleccionada
    selectedModalidadId() {
      if (!this.localState.modalidad) return null
      
      const modalidadProgram = this.basicPrograms.find(p => 
        p.Metas && p.Metas.name === this.localState.modalidad
      )
      
      return modalidadProgram?.id || null
    }
  },

  // Observadores
  watch: {
    // Observador para cargar programas cada vez que cambia el año
    'localState.year': {
      immediate: false, // Cambiado a false para no ejecutar automáticamente
      handler(newYear, oldYear) {
        if (newYear) { // Solo cargar si hay un año seleccionado
          this.loadPrograms(newYear)
        } else {
          this.basicPrograms = []
          this.programsWithLocations = []
        }
        
        // Solo reinicia selecciones si el año REALMENTE cambió (no en actualizaciones del stepper)
        // Y solo si no hay datos guardados en el stepper
        const yearReallyChanged = oldYear !== undefined && String(oldYear) !== String(newYear)
        const hasStepperData = this.stepperData && this.stepperData.modalidad && this.stepperData.program
        
        if (yearReallyChanged && !hasStepperData) {
          // Limpiar selecciones cuando cambia el curso
          this.localState.program = null
          this.localState.modalidad = null
          this.programsWithLocations = []
          this.showModalidadDetails = false
          this.showProgramDetails = false
        }
      }
    },
    
    // Sincronizar datos del stepper cuando cambien las props
    stepperData: {
      handler(newData) {
        // No sincronizar automáticamente - dejar que el usuario seleccione
        // Solo sincronizar si hay datos explícitamente guardados
        if (newData && newData.year && newData.modalidad && newData.program) {
          this.syncWithStepperData()
        }
      },
      immediate: false,
      deep: true
    }
  },

  // Métodos del componente
  mounted() {
    // Inicializar con arrays vacíos - no cargar automáticamente
    this.basicPrograms = []
    this.programsWithLocations = []
  },
  
  methods: {
    /**
     * Carga programas básicos desde servicio para obtener modalidades
     * @param {number|string} year Año escolar o 'e' para egresado
     */
    async loadPrograms(year) {
      if (!year) return
      this.loading = true
      
      try {
        // Cargar programas básicos para obtener modalidades
        this.basicPrograms = await programsService.getProgramsWithoutChildren(year, true)
        
      } catch (error) {
        console.error('Error cargando programas básicos:', error)
        this.basicPrograms = []
      } finally {
        this.loading = false
      }
    },

    /**
     * Carga programas con ubicaciones desde la API específica cuando se selecciona una modalidad
     * @param {string} modalidadName Nombre de la modalidad (opcional, si no se pasa usa this.localState.modalidad)
     */
    async loadProgramsFromAPI(modalidadName = null) {
      // Usar el parámetro o el estado local
      const modalidadSeleccionada = modalidadName || this.localState.modalidad
      
      if (!modalidadSeleccionada) {
        console.error('No hay modalidad seleccionada')
        return
      }
      
      // Calcular el ID directamente aquí para evitar problemas de timing con computed properties
      const modalidadProgram = this.basicPrograms.find(p => 
        p.Metas && p.Metas.name === modalidadSeleccionada
      )
      
      const modalidadId = modalidadProgram?.id
      
      if (!modalidadId) {
        console.error('No se pudo obtener el ID de la modalidad:', modalidadSeleccionada)
        return
      }
      
      this.loading = true
      
      try {
        // Cargar programas con ubicaciones desde la API específica usando el ID de la modalidad
        this.programsWithLocations = await programsService.getProgramsWithLocations(modalidadId)
        
      } catch (error) {
        console.error('Error cargando programas con ubicaciones:', error)
        this.programsWithLocations = []
      } finally {
        this.loading = false
      }
    },





    /**
     * Selecciona año escolar
     * @param {number|string} year Valor del año (3, 4, 'e')
     */
    selectYear(year) {
      this.localState.year = year === 'e' ? 'e' : year
      
      // Limpiar selecciones de modalidad y programa cuando cambia el curso
      this.localState.modalidad = null
      this.localState.program = null
      this.programsWithLocations = []
      this.showModalidadDetails = false
      this.showProgramDetails = false
      
      this.updateStepperData()
    },

    /**
     * Selecciona modalidad
     * @param {string} modName Nombre de la modalidad
     */
    async selectModalidad(modName) {
      this.localState.modalidad = modName
      this.localState.program = null
      
      // Cargar programas desde la API cuando se selecciona una modalidad
      await this.loadProgramsFromAPI(modName)
      
      this.updateStepperData()
    },

    /**
     * Selecciona programa
     * @param {Object} prog Programa a seleccionar
     */
    selectProgram(prog) {
      
      // Los programas ya incluyen las ubicaciones desde la carga de modalidad
      this.localState.program = prog
      
      this.updateStepperData()
    },

    /**
     * Acorta nombre del programa removiendo año o 'egresado'
     * @param {string} name Nombre original
     * @returns {string} Nombre corto
     */
    getShortProgramName(name) {
      if (!name) return ''
      // Acepta singular/plural y ambos caracteres de ordinal (° U+00B0 y º U+00BA)
      // Ej: "4° medio", "4º Medios", "Egresado", "Egresados"
      const regex = /(\s*([0-9]+\s*[°º]\s*medios?|egresad[oa]s?))+/i
      let result = name.replace(regex, '').replace(/\s+PDVx/i, ' PDVx').trim()
      
      // Cambiar "Grupos de Estudio" a "Grupo de Estudio"
      result = result.replace(/grupos\s+de\s+estudio/gi, 'Grupo de Estudio')
      
      // Cambiar "Grupo de Estudios" a "Grupo de Estudio"
      result = result.replace(/grupo\s+de\s+estudios/gi, 'Grupo de Estudio')
      
      return result
    },

    /**
     * Transforma el nombre de modalidad según reglas específicas
     * @param {string} name Nombre original de modalidad
     * @returns {string} Nombre transformado
     */
    getModalidadDisplayName(name) {
      if (!name) return ''
      const lowerName = name.toLowerCase()
      
      // Regla general: extraer solo la palabra clave principal
      if (lowerName.includes('presencial')) {
        return 'Presencial'
      } else if (lowerName.includes('streaming')) {
        return 'Streaming'
      }
      
      // Transformaciones específicas para otras palabras clave
      if (lowerName.includes('pdvx')) {
        return 'Streaming'
      } else if (lowerName.includes('online')) {
        return 'Online'
      } else if (lowerName.includes('tradicional')) {
        return 'Presencial'
      } else if (lowerName.includes('mentoring') || lowerName.includes('mentoría') || lowerName.includes('mentoria')) {
        return 'Mentoría'
      } else if (lowerName.includes('esencial')) {
        return 'Esencial'
      }
      // Por defecto, si no tiene ninguna palabra clave, es Presencial
      return 'Presencial'
    },


    /**
     * Actualiza los datos del stepper
     */
    updateStepperData() {
      
      this.$emit('update-data', {
        year: String(this.localState.year),
        modalidad: this.localState.modalidad,
        program: this.localState.program
      })
    },

    /**
     * Sincroniza el estado local con los datos del stepper
     */
    syncWithStepperData() {
      if (this.stepperData) {
        if (this.stepperData.year && String(this.stepperData.year) !== String(this.localState.year)) {
          this.localState.year = String(this.stepperData.year)
        }
        
        if (this.stepperData.modalidad !== this.localState.modalidad) {
          this.localState.modalidad = this.stepperData.modalidad || null
        }
        
        if (this.stepperData.program !== this.localState.program) {
          this.localState.program = this.stepperData.program || null
        }
      }
    },

    /**
     * Navega al siguiente paso del flujo
     */
    goToNextStep() {
      if (this.canContinue) {
        this.updateStepperData()
        this.$emit('next-step')
      }
    },

    /**
     * Redirige al inicio de la aplicación
     */
    goToHome() {
      this.$router.push({
        path: '/',
        query: { ...this.$route.query }
      })
    },
  }
}

</script>

<style scoped>
html, body {
  font-size: 15px;
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
}

.step1-container {
  padding: 16px;
  max-width: 900px;
  margin: 0 auto;
  font-size: 1rem;
}

.section-title {
  font-family: "Poppins-Medium";
  font-size: 1.15rem;
  font-weight: 100;
  margin-bottom: 4px;
}

.section-subtitle {
  font-family: "Poppins-Medium";
  font-weight: 100;
  font-size: 0.98rem;
  color: #666;
  margin-bottom: 16px;
}

.year-selector {
  display: flex;
  gap: 12px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.year-btn {
  background: #f5f5f5;
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 0.95rem;
  font-family: "Poppins-Medium";
  font-weight: 100;
  color: #444;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
}

.year-btn.active {
  background: #409eff;
  color: #fff;
}

.card-section {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 20px 16px 12px 16px;
  margin-bottom: 24px;
}

.toggle-btns {
  font-family: "Poppins-Medium";
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.toggle-btn {
  font-family: "Poppins-Medium";
  font-weight: 100;
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.95rem;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.toggle-btn.active {
  background: #409eff;
  color: #fff;
}

.details-toggle {
  color: #444;
  font-size: 0.95rem;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  user-select: none;
  width: fit-content;
}

.details-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.details-card.organized-details {
  background: #f7f8fa;
  border-radius: 16px;
  padding: 18px 16px 12px 16px;
  min-width: 200px;
  max-width: 100%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-bottom: 0;
  flex: 1;
}

.details-title {
  font-family: "Poppins-Medium";
  font-size: 1.05rem;
  font-weight: bold;
  margin-bottom: 12px;
  color: #222;
}

.main-details-list,
.category-details-list {
  list-style: none;
  padding: 0;
  margin: 0 0 8px 0;
}

.main-details-list li,
.category-details-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 6px;
  font-size: 0.95rem;
  line-height: 1.45;
}

.icon-detail {
  display: inline-block;
  min-width: 1.2em;
  text-align: center;
  margin-right: 8px;
}

.green {
  color: #27ae60 !important;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 2px;
}

.main-detail-label {
  font-family: "Poppins-Medium";
  font-weight: 100;
  margin-right: 4px;
  color: #222;
  font-size: 0.95rem;
}

.main-detail-value {
  color: #444;
  font-size: 0.95rem;
  margin-right: 6px;
}

.category-block {
  margin-top: 12px;
  margin-bottom: 6px;
}

.category-title {
  font-weight: bold;
  color: #222;
  margin-bottom: 6px;
  font-size: 0.96rem;
}

.category-detail-label {
  font-weight: 500;
  margin-right: 4px;
  color: #333;
  font-size: 0.95rem;
}

.category-detail-value {
  color: #444;
  font-size: 0.95rem;
  margin-right: 6px;
}

.nav-btns {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin: 28px 0 18px 0;
  flex-wrap: wrap;
}

.back-btn, .continue-btn {
  border: none;
  border-radius: 24px;
  padding: 10px 24px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  background: #f5f5f5;
  color: #888;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
}

/* Botón continuar habilitado: fondo negro, texto blanco */
.continue-btn:enabled {
  background: #111;
  color: #fff;
}

.continue-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #111;
  color: #fff;
}

.arrow-icon {
  transition: transform 0.2s;
  display: inline-block;
  vertical-align: middle;
}

.arrow-icon.rotated {
  transform: rotate(180deg);
}

.x-red {
  color: #e74c3c !important;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 2px;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  margin-bottom: 24px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-indicator p {
  color: #666;
  font-size: 0.96rem;
  margin: 0;
}

/* ===== RESPONSIVE DESIGN ===== */

/* Mobile Small (320px - 480px) */
@media (max-width: 480px) {
  .step1-container {
    padding: 12px;
  }
  
  .section-title {
    font-size: 1.1rem;
  }
  
  .section-subtitle {
    font-size: 0.9rem;
    margin-bottom: 12px;
  }
  
  .year-selector {
    gap: 8px;
    margin-bottom: 24px;
  }
  
  .year-btn {
    padding: 10px 16px;
    font-size: 0.9rem;
    border-radius: 8px;
  }
  
  .card-section {
    padding: 16px 12px 10px 12px;
    margin-bottom: 20px;
    border-radius: 12px;
  }
  
  .toggle-btns {
    gap: 8px;
    margin-bottom: 12px;
  }
  
  .toggle-btn {
    padding: 8px 14px;
    font-size: 0.9rem;
    border-radius: 6px;
  }
  
  .details-card.organized-details {
    padding: 16px 12px 10px 12px;
    min-width: 100%;
    border-radius: 12px;
  }
  
  .details-title {
    font-size: 1rem;
  }
  
  .main-details-list li,
  .category-details-list li {
    font-size: 0.9rem;
  }
  
  .nav-btns {
    gap: 12px;
    margin: 24px 0 16px 0;
  }
  
  .back-btn, .continue-btn {
    padding: 10px 20px;
    font-size: 0.9rem;
    border-radius: 20px;
  }
}

/* Mobile Medium (481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
  .step1-container {
    padding: 16px;
  }
  
  .year-selector {
    gap: 10px;
  }
  
  .year-btn {
    padding: 12px 18px;
  }
  
  .card-section {
    padding: 20px 16px 12px 16px;
  }
  
  .toggle-btns {
    gap: 10px;
  }
  
  .toggle-btn {
    padding: 9px 16px;
  }
  
  .details-card.organized-details {
    min-width: 180px;
  }
}

/* Tablet (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .step1-container {
    padding: 20px;
    max-width: 800px;
  }
  
  .year-selector {
    gap: 14px;
  }
  
  .year-btn {
    padding: 14px 24px;
    font-size: 1rem;
  }
  
  .card-section {
    padding: 24px 20px 14px 20px;
  }
  
  .toggle-btns {
    gap: 12px;
  }
  
  .toggle-btn {
    padding: 10px 18px;
    font-size: 0.98rem;
  }
  
  .details-card.organized-details {
    min-width: 220px;
    max-width: 350px;
  }
  
  .nav-btns {
    gap: 18px;
  }
  
  .back-btn, .continue-btn {
    padding: 12px 28px;
    font-size: 1rem;
  }
}

/* Desktop (1024px+) */
@media (min-width: 1024px) {
  .step1-container {
    padding: 24px;
    max-width: 900px;
  }
  
  .year-selector {
    gap: 16px;
  }
  
  .year-btn {
    padding: 14px 28px;
    font-size: 1rem;
  }
  
  .card-section {
    padding: 28px 24px 16px 24px;
  }
  
  .toggle-btns {
    gap: 12px;
  }
  
  .toggle-btn {
    padding: 10px 20px;
    font-size: 0.98rem;
  }
  
  .details-card.organized-details {
    min-width: 220px;
    max-width: 400px;
  }
  
  .nav-btns {
    gap: 20px;
  }
  
  .back-btn, .continue-btn {
    padding: 12px 30px;
    font-size: 1rem;
  }
}

/* Large Desktop (1280px+) */
@media (min-width: 1280px) {
  .step1-container {
    max-width: 1000px;
  }
  
  .card-section {
    padding: 32px 28px 20px 28px;
  }
  
  .details-card.organized-details {
    max-width: 450px;
  }
}

/* Landscape Mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .step1-container {
    padding: 12px;
  }
  
  .card-section {
    margin-bottom: 16px;
    padding: 16px 14px 10px 14px;
  }
  
  .year-selector {
    margin-bottom: 20px;
  }
  
  .nav-btns {
    margin: 20px 0 12px 0;
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .year-btn,
  .toggle-btn,
  .back-btn,
  .continue-btn {
    border-width: 1px;
  }
}

/* ===== COMPONENT SPACING ===== */

/* Espaciado responsivo para componentes anidados */
@media (max-width: 480px) {
  .step1-container > div:last-child {
    margin-top: 80px !important;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  .step1-container > div:last-child {
    margin-top: 100px !important;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .step1-container > div:last-child {
    margin-top: 120px !important;
  }
}

@media (min-width: 1024px) {
  .step1-container > div:last-child {
    margin-top: 140px !important;
  }
}

/* ===== ACCESSIBILITY IMPROVEMENTS ===== */

/* Mejoras de accesibilidad */
@media (prefers-reduced-motion: reduce) {
  .year-btn,
  .toggle-btn,
  .back-btn,
  .continue-btn {
    transition: none;
  }
  
  .arrow-icon {
    transition: none;
  }
}

/* ===== PRINT STYLES ===== */

@media print {
  .step1-container {
    background: white;
    color: black;
    padding: 20px;
  }
  
  .card-section {
    border: 1px solid #ccc;
    box-shadow: none;
    break-inside: avoid;
  }
  
  .year-btn,
  .toggle-btn,
  .back-btn,
  .continue-btn {
    border: 1px solid #ccc;
    background: white;
    color: black;
  }
  
  .year-btn.active,
  .toggle-btn.active {
    background: #f0f0f0;
    color: black;
  }
  
  .continue-btn:enabled {
    background: #f0f0f0;
    color: black;
  }
}
</style>
